/**
 * Resolves whether Create RMA item restocking fee UI/value is allowed
 * from Refund/Exchange resolution capabilities (same source as Policies fees).
 */

import { RESOLUTION_ID, RESOLUTION_TYPE } from "../../resolutions/constants";
import { resolveFeesCapability } from "../../policies/utils/resolve-fees-capability";

/**
 * Maps a Create RMA merchant resolution type onto a system RESOLUTION_ID
 * sufficient for resolveFeesCapability branching (cancel / exchange / refund).
 */
export function mapResolutionTypeToCapabilityResolutionId(
	resolutionType: RESOLUTION_TYPE | undefined | null,
): RESOLUTION_ID | undefined {
	if (resolutionType == null) {
		return undefined;
	}

	switch (resolutionType) {
		case RESOLUTION_TYPE.CancelOrderType:
			return RESOLUTION_ID.CANCEL_ORDER;
		case RESOLUTION_TYPE.DirectVariantExchange:
			return RESOLUTION_ID.INSTANT_VARIANT_EXCHANGE;
		case RESOLUTION_TYPE.ManualExchangeType:
			return RESOLUTION_ID.MANUAL_EXCHANGE;
		case RESOLUTION_TYPE.ProductExchangeType:
			return RESOLUTION_ID.PRODUCT_EXCHANGE;
		default:
			return RESOLUTION_ID.ORIG_PAY_REFUND;
	}
}

export function isRestockingFeeSupportedForResolution(
	resolutionId: RESOLUTION_ID | undefined,
): boolean {
	return resolveFeesCapability(resolutionId).isRestockingFeeSupported === true;
}
